export default "__VITE_ASSET__mKWhQSDh__"